import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let searchDate = moment().startOf('year').format('YYYY');

//화면 진입시 초기화
const getInit = () => {
	return {
		searchParams: {
			partType: 'MEA', 
			searchDate: searchDate 
		},
		partTypeList: [
            {
                "commCd": "MEA",
                "commCdName": "MEA",
                "commCdType": "PART_G"
            },
            {
                "commCd": "EGA",
                "commCdName": "EGA",
                "commCdType": "PART_G"
            }
        ], 
		mdjTbList: [], 
		dayCols: [],
		graphBarStackChartInfo: [], 
		graphLineChartInfo: [], 
		isLoading: false 
	};
};

export default {
	...common,
	[types.STATE_INIT]: state => {
		Object.assign(state, getInit());
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	}
};
